import { GridRowId } from '@mui/x-data-grid';

import { authApi } from './authApi';
import { getLocalStorage } from '../hooks/authentication';
import { IDraft } from '../interfaces/IDraft';
import { IObject } from '../interfaces/IObject';
import { IResponse } from '../interfaces/IResponse';

const BASE_URL = process.env.REACT_APP_RIVERUS_ULTRA_API;

export const getDrafts = async (
  params: string
): Promise<IResponse<IDraft[]>> => {
  return await authApi.get(`draft/${params}`);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const addDraft = async (payload: any) => {
  const formData = new FormData();
  Object.keys(payload).forEach((key) => {
    formData.append(key, payload[key]);
  });
  return await authApi.post('draft/', formData);
};

export const getDocument = async (payload: IObject) => {
  return await authApi.post('azure/presigned-url/', payload);
};

export const getContractType = async (): Promise<IResponse<IObject[]>> => {
  return await authApi.get('admin/contract_type/');
};

export const getSections = async (draftId: string) => {
  return await authApi.get(`/draft/sections/${draftId}/`);
};

export const getInsights = async (draftId: string, fieldId: string) => {
  return await authApi.get(`/draft/insights/${draftId}/${fieldId}/`);
};

export const deleteDrafts = async (ids: GridRowId[]) => {
  const data = { ids: ids };
  return await authApi.post('draft/bulk-delete/', data);
};

export const createCompareDraft = async (payload: IObject) => {
  return await authApi.post('compare-docx/', payload);
};

export const getCompareDocxData = async (
  payload: IObject
): Promise<IResponse<IObject[]>> => {
  return await authApi.post('export-compare-docx/', payload);
};

export const downloadCompareDocx = async (payload: IObject) => {
  return (
    fetch(`${BASE_URL}export-compare-docx/`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${getLocalStorage(`accessToken`)}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then((response) => (response as any).blob())
      .then((blob) => blob)
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getChat = async (payload: any) => {
  return await authApi.post('live_chat/', payload);
};
